import { FC,useRef, Fragment } from 'react';
import Spacer from '@components/Spacer';
import { pickProductIcon } from '@components/ProductIcon';
import pluralize from 'pluralize';
import * as ApiModels from '@typings/api-models';
import ProgressIndicator from '@components/ProgressIndicator';
import CollapsibleArea from '@components/CollapsibleArea';
import { Reorder } from 'framer-motion';

import s from './ReorderServiceModal.module.scss';

type FullProduct = Pick<ApiModels.Product, 'id' | 'title' | 'initiateCaseRank'> & {
  productTypes: Array<Pick<ApiModels.ProductType, 'noodleProductType'>>;
  workflows: Array<Pick<ApiModels.Workflow, 'id' | 'name'>>;
};

type Props = {
  fullProducts: FullProduct[];
  isFetching: boolean;
  onOrderChange: (updatedProducts: FullProduct[]) => void;
};

const ReorderService: FC<Props> = ({ fullProducts, isFetching, onOrderChange }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className={s.workflowSelect}>
      {isFetching
        ? (
          <ProgressIndicator isCentered />
        )
        : (
          <>
            <div className={s.products} ref={containerRef}>
              {fullProducts.length === 0 && <p className="body-sm">No workflows found.</p>}
              <Reorder.Group values={fullProducts} onReorder={onOrderChange} className={s.reorderGroup}>
                {fullProducts.map(product => {
                  const Icon = pickProductIcon(product.productTypes?.[0]?.noodleProductType);
                  return (
                    <Reorder.Item key={product.id} value={product}>
                      <CollapsibleArea
                        title={product.title as string}
                        description={pluralize('workflow', product.workflows.length, true)}
                        key={product.id}
                        Icon={Icon ? { Component: Icon, color: 'var(--color-noodle)' } : undefined}
                        className={s.details}
                        caretPosition={'right'}
                        draggable
                        onlyToggleOnCaret
                      >
                        <Spacer size="16px" />
                        <div className={s.workflows}>
                          {product.workflows.map(workflow => (
                            <div key={workflow.id} className={s.workflow}>
                              <p className="caption">{workflow.name}</p>
                            </div>
                          ))}
                        </div>
                      </CollapsibleArea>
                    </Reorder.Item>
                  );
                })}
              </Reorder.Group>
            </div>
          </>
        )}
    </div>
  );
};

export default ReorderService;
